module.exports = __webpack_public_path__ + "2c7ce9c7b604b9bf511dbd1b3cff13bc.png";